'use strict';

class Translator {
	constructor() {
		if (!window.translations) {
			throw new Error();
		}
	}

	static translate(message, count = 1) {
		if (Object.prototype.hasOwnProperty.call(window.translations, message) && count === 1) {
			return window.translations[message];
		}

		count = Math.abs(count);
		if (count > 2 && count <= 4) {
			count = 2;
		} else if (count > 5) {
			count = 5;
		}

		let countKey = message + '.' + count;
		if (Object.prototype.hasOwnProperty.call(window.translations, countKey)) {
			return window.translations[countKey];
		}
		return message;
	}
}

module.exports = Translator;
